var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-result-modal",class:{
    'invisible': _vm.isShowingImage
  }},[_c('div',{staticClass:"modal-content"},[_c('h4',{staticClass:"header"},[_vm._v("\n      "+_vm._s(_vm.$t('Results are hidden'))+"\n    ")]),_c('p',{staticClass:"submission"},[_vm._v("\n      "+_vm._s(_vm.submissionText)+"\n    ")]),_c('aha-button',{on:{"click":_vm.showResult}},[_vm._v("\n      "+_vm._s(_vm.$t('Show results'))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }